import { useRef, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { fileMapUtils } from '@fanfanlo';



export function FallDownVideoPlayer() {// 视频源配置

    const fallDownImg = fileMapUtils.getFile('/images/fall-down-video/fall-down-001.jpg')
    console.log('falldown img', fallDownImg)
    const falldownVideo = fileMapUtils.getFile('/video/fall-down/fall-down.mp4')
    console.log('falldownVideo=', falldownVideo)
    const VIDEO_CONFIG = {
      src: falldownVideo, // 视频路径，请根据实际项目结构调整
      type: 'video/mp4',
      poster: fallDownImg, // 封面图片路径
      controls: true,
      muted: false,
      loop: true,
    };
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // 组件挂载时初始化
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // 初始化视频
    const initVideo = () => {
      console.log('视频组件已初始化');
      // 可以在这里设置视频的初始状态
      videoElement.load();
    };

    // 视频加载完成回调
    const handleLoadedData = () => {
      console.log('视频加载完成');
    };

    // 播放状态变化处理
    const handlePlay = () => {
      console.log('视频开始播放');
      setIsPlaying(true);
    };

    const handlePause = () => {
      console.log('视频已暂停');
      setIsPlaying(false);
    };

    // 添加事件监听
    videoElement.addEventListener('loadeddata', handleLoadedData);
    videoElement.addEventListener('play', handlePlay);
    videoElement.addEventListener('pause', handlePause);

    // 初始化视频
    initVideo();

    // 清理函数：组件卸载时执行
    return () => {
      console.log('清理视频资源');
      
      // 暂停视频
      if (!videoElement.paused) {
        videoElement.pause();
      }
      
      // 清除视频源
      if (videoElement.src) {
        videoElement.src = '';
      }
      
      // 移除事件监听
      videoElement.removeEventListener('loadeddata', handleLoadedData);
      videoElement.removeEventListener('play', handlePlay);
      videoElement.removeEventListener('pause', handlePause);
      
      // 清除媒体元素
      if (videoElement.load) {
        videoElement.load();
      }
    };
  }, []);

  return (
    <Box
      component="div"
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        controls={VIDEO_CONFIG.controls}
        muted={VIDEO_CONFIG.muted}
        loop={VIDEO_CONFIG.loop}
        poster={VIDEO_CONFIG.poster}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          backgroundColor: '#000',
          display: 'block',
        }}
      >
        <source src={VIDEO_CONFIG.src} type={VIDEO_CONFIG.type} />
        您的浏览器不支持 HTML5 视频标签。
      </video>
    </Box>
  );
}